import React, {useState, useEffect} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {Responsive, WidthProvider} from "react-grid-layout";
import "../../../../../node_modules/react-grid-layout/css/styles.css";
import "../../../../../node_modules/react-resizable/css/styles.css";
import {WidgetTypesPanelExpanded} from "./WidgetTypesPanelExpanded";
import {WidgetTypesPanelCollapsed} from "./WidgetTypesPanelCollapsed";
import {WidgetTypes} from "./WidgetTypes";
import * as dashboardApi from "../../../../_services/dashboard.service";
import {WidgetFactory} from "../../../widgets/WidgetFactory";
import {toast} from "react-toastify";
import appViewModeConstants from "../../../../_constants/app.view.mode.constants";

const ResponsiveGridLayout = WidthProvider(Responsive);

const useStyles = makeStyles((theme) => ({
  dashboard: { ...theme.dashboard.gridLayoutDashboard.dashbaordGridLayout.dashboard },
  dashboardPanel: { ...theme.dashboard.gridLayoutDashboard.dashbaordGridLayout.dashboardPanel },
  dashboardPanel_DashboardGrid: {...theme.dashboard.gridLayoutDashboard.dashbaordGridLayout.dashboardPanel_DashboardGrid },
  widgetPanelListMaximize: {...theme.dashboard.gridLayoutDashboard.dashbaordGridLayout.widgetPanelListMaximize },
  widgetPanelListMinimize: {...theme.dashboard.gridLayoutDashboard.dashbaordGridLayout.widgetPanelListMinimize },
}));

const breakpointColumns = {
  XXS: 3,
  XS: 6,
  S: 12,
  M: 20,
  L: 40
};

const widgetTypes = JSON.parse(JSON.stringify(WidgetTypes));

export const DashboardGridLayout = ({
  dashboardId = "00000000-0000-0000-0000-000000000000",
  dashboardWidgets = [], 
  isInEditMode,
  isPublicViewMode = false,
  brandingSettings = {},
  clientType = null,
  breakpoint
}) => {
  let classes = useStyles({...brandingSettings, isInEditMode, breakpoint});
  const [widgets, setWidgets] = useState(dashboardWidgets);
  const defaultDroppingElementId = "__dropping-elem__";
  //// NEW DASHBOARD GRID LAYOUT
  const [droppedWidgetType, setDroppedWidgetType] = useState(1);
  const [isWidgetListExpanded, setIsWidgetListExpanded] = useState(false);
  const [isPreventDraggable, setIsPreventDraggable] = useState(false);
 
  const [layoutsForRender, setLayoutsForRender] = useState({lg: [], md: [], sm: [], sx: [], xxs: []});
  
  useEffect(() => {
    setIsPreventDraggable(isInEditMode);
  }, [isInEditMode]);

  useEffect(() => {
      setWidgets(dashboardWidgets);
  }, [dashboardWidgets]);

  function onDrop(layout, item) { //onDrop(layout, item, e)
    let widgetTypeList = JSON.parse(JSON.stringify(widgetTypes)); // copy the widgetTypes
    const widgetSetting = widgetTypeList.filter(a => a.id === droppedWidgetType)[0];
    if (item !== undefined) {
      widgetSetting.dashboardId = dashboardId;
      widgetSetting.dashboardWidgetId = "00000000-0000-0000-0000-000000000000"; // temp guid
      widgetSetting.i = widgetSetting.dashboardWidgetId;
      widgetSetting.widgetType = widgetSetting.id; // create widgetType value the same as the id because it's needed to create the widget type
      // update position (X,Y)
      widgetSetting.dimensions = [{dashboardWidgetId: widgetSetting.dashboardWidgetId, dimensionsType: breakpoint, x: item.x, y: item.y, w: widgetSetting.w, h: widgetSetting.h }];
      dashboardApi.addWidgets(dashboardId, [widgetSetting]).then (result => {
        widgetSetting.dashboardWidgetId = result.data[0];
        widgetSetting.i = result.data[0];
        //currLayout.filter(a => a.i === defaultDroppingElementId)[0].i = result.data[0];
        setWidgets(prev => {
          return [...prev, widgetSetting];
        }); /// replace it with new layout
      }).catch((error) => {
        toast.error(error, { autoClose: false });
      });
    } 
  }
  
  function onAddingNewWidget(widgetType) {
    let widgetTypeList = JSON.parse(JSON.stringify(widgetTypes)); // copy the widgetTypes
    const widgetSetting = widgetTypeList.filter(a => a.id === widgetType)[0];
    widgetSetting.dashboardId = dashboardId;
    widgetSetting.dashboardWidgetId = "00000000-0000-0000-0000-000000000000"; // temp guid
    widgetSetting.i = widgetSetting.dashboardWidgetId;
    widgetSetting.widgetType = widgetSetting.id; // create widgetType value the same as the id because it's needed to create the widget type
    widgetSetting.dimensions = [{dashboardWidgetId: widgetSetting.dashboardWidgetId, dimensionsType: breakpoint, x: 0, y: 0, w: widgetSetting.w, h: widgetSetting.h }];
    dashboardApi.addWidgets(dashboardId, [widgetSetting]).then (result => {
      widgetSetting.dashboardWidgetId = result.data[0];
      widgetSetting.i = result.data[0];
      setWidgets(prev => {
        return [...prev, widgetSetting];
      }); /// replace it with new layout
    }).catch((error) => {
      toast.error(error, { autoClose: false });
    });
  }
 
  function onSetDroppedWidgetType(widgetType) {
    setDroppedWidgetType(widgetType);
  }
  
  function onDelete(deletedDashboardWidgetId) {
    // delete the serverside
    dashboardApi.deleteWidget(deletedDashboardWidgetId).then(() => {
      toast.success("Widget was deleted successfully.");
      // update the dashboardWidgetList object
      setWidgets((prev) => {
        return prev.filter(a => a.dashboardWidgetId !== deletedDashboardWidgetId);
      });
    }).catch((error) => {
      toast.error(error, { autoClose: false });
    });
  }  
  
  const getAudio = () => {
    return document.getElementById("audio");
  }

  // This variable is used only in edit mode.
  const cols = breakpointColumns[breakpoint];
  
  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
  }, [layoutsForRender]);

  useEffect(() => {
    const createLayoutForRender = (dimensionsType) => {
      return widgets.map(w => {
        const widgetType = widgetTypes.find((wt) => wt.id === w.widgetType);
        let dimension = w.dimensions.find((d) => d.dimensionsType === dimensionsType);
        if (!dimension) {
          // If the database has no dimension of the selected breakpoint, try to find the dimension
          // for the largest breakpoint. If that is not found, use 0s for placement and size from
          // the widget type.
          const breakpointSizes = ['L', 'M', 'S', 'XS', 'XXS'];
          for( let i = 0; i < 5; i++) {
            const breakpointSize = breakpointSizes[i];
            dimension = w.dimensions.find( d => d.dimensionsType === breakpointSize);
            if (dimension) break;
          }
          if (!dimension) {
            dimension = {x: 0, y: 0, w: widgetType.w, h: widgetType.h};
          }
        }
  
        return {
          i: w.dashboardWidgetId,
          x: dimension.x,
          y: dimension.y,
          w: dimension.w,
          h: dimension.h,
          minW: widgetType ? widgetType.minW ?? 1 : 1,
          maxW: widgetType ? widgetType.maxW ?? Infinity : Infinity,
          minH: widgetType ? widgetType.minH ?? 1 : 1,
          maxH: widgetType ? widgetType.maxH ?? Infinity : Infinity,
        };
      });
    };

    setLayoutsForRender({
      lg: createLayoutForRender(isInEditMode? breakpoint : 'L'),
      md: createLayoutForRender(isInEditMode? breakpoint : 'M'),
      sm: createLayoutForRender(isInEditMode? breakpoint : 'S'),
      xs: createLayoutForRender(isInEditMode? breakpoint : 'XS'),
      xxs: createLayoutForRender(isInEditMode? breakpoint : 'XXS')
    });

  }, [isInEditMode, breakpoint, widgets]);
  
  return (
    <div className={classes.dashboard} id={"test"}>
      <div className={classes.dashboardPanel} >
        <div className={classes.dashboardPanel_DashboardGrid}>
          <ResponsiveGridLayout
            style={{ minHeight: "100%"}}
            layouts={layoutsForRender}
            breakpoints={{lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
            rowHeight={32}
            key="responsiveGridLayout"
            isDroppable={isInEditMode && isPreventDraggable} // set isDroppable depending on whether it's draggable or not
            isDraggable={isInEditMode && isPreventDraggable}
            isResizable={isInEditMode}
            resizeHandles={["se"]} //{['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne']}
            onLayoutChange={(layout) => { //(layout, layouts) 
              if (!isInEditMode) {
                return;
              }
              /*setWidgets((prev) => {
                const newWidgets = prev.map((w) => {
                  const newLayout = layout.filter(
                    (l) => l.i === w.dashboardWidgetId
                  )[0];
                  if (newLayout) {
                    return {
                      ...w,
                      dimensions: w.dimensions.map((d) => {
                        if (d.dimensionsType === breakpoint) {
                          return {
                            ...d,
                            x: newLayout.x,
                            y: newLayout.y,
                            w: newLayout.w,
                            h: newLayout.h
                          };
                        } else {
                          return d;
                        }
                      })
                    };
                  } else {
                    return w;
                  }
                });
                dashboardApi.updateWidgetsPosition(newWidgets).catch((error) => {
                  toast.error(error, { autoClose: false });
                });
                return newWidgets; 
              }); */
            }}
            onResizeStop={(layout) => { // (layout, oldItem, newItem, placeholder, e, element)
              setWidgets((prev) => {
                const newWidgets = prev.map((w) => {
                  let newLayout = layout.filter(
                    (l) => l.i === w.dashboardWidgetId
                  )[0];
                  if (newLayout) {
                    return {
                      ...w,
                      dimensions: [
                        ...w.dimensions.filter(d => d.dimensionsType !== breakpoint),
                        { 
                         dimensionsType: breakpoint, dashboardWidgetId: w.dashboardWidgetId, 
                         x: newLayout.x, y: newLayout.y, w: newLayout.w, h: newLayout.h
                       }
                     ]
                    };
                  } else {
                    return w;
                  }
                });
                dashboardApi.updateWidgetsPosition(newWidgets).catch((error) => {
                  toast.error(error, { autoClose: false });
                });
                return newWidgets;
              });
            }}
            onDrag={(layout, oldItem, newItem, placeholder) => { //(layout, oldItem, newItem, placeholder, e, element)
              if (placeholder.i === defaultDroppingElementId) {
                let droppedWidget = WidgetTypes.filter(a => a.id === droppedWidgetType)[0];
                if (droppedWidget) {
                  placeholder.w = droppedWidget.w;
                  placeholder.h = droppedWidget.h;
                }
              }
            }}
            onDragStop={(layout) => { //(layout, oldItem, newItem, placeholder, e, element)
              setWidgets((prev) => {
                const newWidgets = prev.map((w) => {
                  let newLayout = layout.filter(
                    (l) => l.i === w.dashboardWidgetId
                  )[0];
                  if (newLayout) {
                    return {
                      ...w,
                      dimensions: [
                         ...w.dimensions.filter(d => d.dimensionsType !== breakpoint),
                         { 
                          dimensionsType: breakpoint, dashboardWidgetId: w.dashboardWidgetId, 
                          x: newLayout.x, y: newLayout.y, w: newLayout.w, h: newLayout.h
                        }
                      ]
                    };
                  } else {
                    return w;
                  }
                });
                dashboardApi.updateWidgetsPosition(newWidgets).catch((error) => {
                  toast.error(error, { autoClose: false });
                });
                return newWidgets;
              });
            }}
            onDrop={onDrop}
            measureBeforeMount={false}
            compactType={"vertical"}
            useCSSTransforms={true}
            cols={ isInEditMode ? { lg: cols, md: cols, sm: cols, xs: cols, xxs: cols } : {lg: 40, md: 20, sm: 12, xs: 6, xxs: 3}}
          >
            {widgets.map((data) => { //(data, index)
              return (
                <div
                  style={{
                    overflow: "hidden",
                  }}
                  key={data.dashboardWidgetId}
                >
                  <WidgetFactory
                    widgetType={data.widgetType}
                    widgetId={data.dashboardWidgetId}
                    viewMode={isInEditMode ? appViewModeConstants.ADMIN_MODE : appViewModeConstants.VIEW_MODE}
                    isPublicViewMode={isPublicViewMode}
                    clientType={clientType}
                    width='100%'
                    setIsDraggable={(value) => { setIsPreventDraggable(value); }}
                    height='100%'
                    onDelete={() => {onDelete(data.dashboardWidgetId); }}
                    brandingSettings={brandingSettings}
                    onAudioPlay={() => getAudio()?.play()}
                  />
                </div>
              );
            })}
          </ResponsiveGridLayout>
        </div>
      </div>
      {isInEditMode ?
        isWidgetListExpanded ? (
              <div className={ classes.widgetPanelListMaximize}>
                <WidgetTypesPanelExpanded   key={"widgetTypesPanel"}
                                  isDraggable={isInEditMode && isPreventDraggable}
                                  onSetDroppedWidgetType={onSetDroppedWidgetType}
                                  onAddingNewWidget={onAddingNewWidget}
                                  onCollapseClick={() => setIsWidgetListExpanded(false)}
                />
              </div>
            ) : (
              <div className={ classes.widgetPanelListMinimize}>
                <WidgetTypesPanelCollapsed key={"widgetTypesPanel"}
                                  isDraggable={isInEditMode && isPreventDraggable}
                                  onSetDroppedWidgetType={onSetDroppedWidgetType}
                                  onAddingNewWidget={onAddingNewWidget}
                                  onExpandClick={() => setIsWidgetListExpanded(true)}
                />
              </div>
        )
       : ("")
      }
    </div>
  );
};